import { render, staticRenderFns } from "./WorkspaceExpandManualAdd.vue?vue&type=template&id=7a5f2f02&scoped=true"
import script from "./WorkspaceExpandManualAdd.vue?vue&type=script&lang=js"
export * from "./WorkspaceExpandManualAdd.vue?vue&type=script&lang=js"
import style0 from "./WorkspaceExpandManualAdd.vue?vue&type=style&index=0&id=7a5f2f02&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a5f2f02",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/CFDE Knowledge - Dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7a5f2f02')) {
      api.createRecord('7a5f2f02', component.options)
    } else {
      api.reload('7a5f2f02', component.options)
    }
    module.hot.accept("./WorkspaceExpandManualAdd.vue?vue&type=template&id=7a5f2f02&scoped=true", function () {
      api.rerender('7a5f2f02', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/researchPortal/customComponents/revealKgWorkspace/WorkspaceExpandManualAdd.vue"
export default component.exports